const noPasswordTemplate = `
   <pwr-no-password>
   </pwr-no-password> `;
export default noPasswordTemplate;
